module.exports = __webpack_public_path__ + "static/media/course.a22cbb3b.svg";